import LoadingPresenter from './LoadingPresenter';
export default LoadingPresenter;
